import * as React from 'react';
import { DocLayout } from './../../layouts/DocLayout';
import { Layout } from 'antd';
import { CompositePurchaseDoc } from './../../containers/CompositePurchaseDoc';

export class CompositePurchaseDocPage extends React.Component {  
  render() {
    return (
      <DocLayout>
        <Layout className="doc-root">
          <CompositePurchaseDoc />
        </Layout>
      </DocLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CompositePurchaseDocPage/index.tsx